var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "vmodal" },
        [
          _c("transition", { attrs: { name: "vmodal-overlay-transition" } }, [
            _vm.visible
              ? _c("div", {
                  staticClass: "vmodal-overlay",
                  on: {
                    click: function($event) {
                      if ($event.target !== $event.currentTarget) {
                        return null
                      }
                      $event.stopPropagation()
                      return _vm.close($event)
                    }
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "vmodal-modal-transition" } }, [
            _vm.visible
              ? _c(
                  "div",
                  {
                    staticClass: "vmodal-container",
                    class: { small: _vm.small },
                    style: { maxWidth: _vm.max_width }
                  },
                  [
                    _c("div", { staticClass: "vmodal-header" }, [
                      _c(
                        "div",
                        { staticClass: "vmodal-header__title" },
                        [_vm._t("title")],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "vmodal-close close",
                        on: { click: _vm.close }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "vmodal-container-content" },
                      [_vm._t("default")],
                      2
                    )
                  ]
                )
              : _vm._e()
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }